var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('new-identification-notify'),_c('idle-worker-disconnect'),_c('tab-blink')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }